import React from 'react';
import CardReplacement from '../components/CardReplacement';


export default function CardReplace() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <main>
        <CardReplacement />
      </main>
      
    </div>
  );
}